import UIPaginator from 'UIComponents/paginator/UIPaginator';
import UISection from 'UIComponents/section/UISection';
import { safeSmoothScrollTo } from '../../../utils/utils';
import { useCatalogSearchParams } from '..';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CatalogSearchPagination = ({
  pageCount
}) => {
  const {
    pageNumber,
    setPageNumber
  } = useCatalogSearchParams();
  const handlePageChange = useCallback(e => {
    setPageNumber(e.target.value);
    safeSmoothScrollTo(window, 0, 0);
  }, [setPageNumber]);
  return /*#__PURE__*/_jsx(UISection, {
    children: /*#__PURE__*/_jsx(UIPaginator, {
      defaultPage: pageNumber || 1,
      onPageChange: handlePageChange,
      pageCount: pageCount,
      showFirstLastButtons: true
    })
  });
};